import * as React from 'react';

import {
	HomePage,
	FaqPage,
	QuestsPage,
	PromotionsPage,
	SupportPage,
	WelcomePage,
	TournamentsPage,
	ShopPage,
	ProfilePage,
	SkinplacePage,
	PromotionDetailedPage,
	PromotionCompletedPage,
	InfoPage,
	CoinRacePage,
	CoinRaceDetailsPage
} from '@pages';
import { ROUTES } from '@utils/routes.ts';

import { TournamentDetail } from '@entities/tournaments';

import { config } from '@/config.ts';

type RouteItem = {
	key: string;
	path: ROUTES;
	element: React.ReactElement;
	devOnly?: boolean;
	isPrivate?: boolean;
	isNavHidden?: boolean;
	isFullscreen?: boolean;
};

export const routeList: RouteItem[] = [
	{ key: 'tournaments_page', path: ROUTES.TOURNAMENTS, element: <TournamentsPage />, isFullscreen: true },
	{ key: 'tournament_page', path: ROUTES.TOURNAMENT, element: <TournamentDetail /> },
	{ key: 'home_page', path: ROUTES.HOME, element: <HomePage /> },
	{ key: 'shop_page', path: ROUTES.SHOP, element: <ShopPage /> },
	{ key: 'shop_home_page', path: ROUTES.HOME, element: <ShopPage /> },
	{ key: 'quests_page', path: ROUTES.QUESTS, element: <QuestsPage /> },
	{ key: 'promotions_page', path: ROUTES.PROMOTIONS, element: <PromotionsPage /> },
	{ key: 'promotion_detailed_page', path: ROUTES.PROMOTION, element: <PromotionDetailedPage />, devOnly: true },
	{
		key: 'promotion_completed_page',
		path: ROUTES.PROMOTION_COMPLETED,
		element: <PromotionCompletedPage />,
		devOnly: true
	},
	{ key: 'support_page', path: ROUTES.SUPPORT, element: <SupportPage /> },
	{ key: 'faq_page', path: ROUTES.FAQ, element: <FaqPage /> },
	{ key: 'welcome_page', path: ROUTES.WELCOME, element: <WelcomePage />, isPrivate: true, isNavHidden: true },
	{ key: 'profile_page', path: ROUTES.PROFILE, element: <ProfilePage />, isPrivate: true },
	{ key: 'skinplace_page', path: ROUTES.SKINPLACE, element: <SkinplacePage /> },
	{ key: 'info_page', path: ROUTES.INFO, element: <InfoPage /> },
	{ key: 'buy_history', path: ROUTES.PROFILE, element: <ProfilePage isBuyHistory />, isPrivate: true },
	{
		key: 'coin_race_details_page',
		path: ROUTES.COIN_RACE_DETAILS,
		element: <CoinRaceDetailsPage />,
		isFullscreen: true
	},
	{ key: 'coin_race_page', path: ROUTES.COIN_RACE, element: <CoinRacePage /> }
];

type BrandRoutesConfig = Record<string, string[]>;

// You can manage routes for different brands with this map.
export const brandRoutesMap: BrandRoutesConfig = {
	default: [
		'home_page',
		'shop_page',
		'quests_page',
		'tournaments_page',
		'tournament_page',
		'promotions_page',
		'promotion_detailed_page',
		'promotion_completed_page',
		'support_page',
		'faq_page',
		'info_page',
		'support_page',
		'profile_page',
		'welcome_page'
		// According to task 2042, open only for COM2
		// 'coin_race_page'
		// 'coin_race_details_page',
	],
	pm: [
		'home_page',
		'shop_page',
		'quests_page',
		'tournaments_page',
		'tournament_page',
		'promotions_page',
		'promotion_detailed_page',
		'promotion_completed_page',
		'support_page',
		'faq_page',
		'info_page',
		'skinplace_page',
		'support_page',
		'profile_page',
		'welcome_page'
		// According to task 2138, close for COM2
		// 'coin_race_page'
		// 'coin_race_details_page',
	],
	rockets: ['home_page', 'shop_page', 'quests_page', 'profile_page', 'welcome_page'],
	nomad: ['home_page', 'shop_page', 'quests_page', 'skinplace_page', 'profile_page', 'welcome_page'],
	blitz: ['shop_home_page', 'support_page', 'profile_page', 'welcome_page'],
	sk2: ['shop_home_page', 'quests_page', 'buy_history', 'welcome_page'],
	com2: [
		'home_page',
		'shop_page',
		'quests_page',
		'tournaments_page',
		'tournament_page',
		'promotions_page',
		'promotion_detailed_page',
		'promotion_completed_page',
		'support_page',
		'faq_page',
		'info_page',
		'support_page',
		'profile_page',
		'welcome_page'
		// 'coin_race_details_page',
		// 'coin_race_page'
	]
};

export const getRouteListForBrand = (brand: string): RouteItem[] => {
	const allowedKeys = brandRoutesMap[brand] ?? brandRoutesMap.default;
	return routeList.filter(route => {
		const isDevOnly = 'devOnly' in route && route.devOnly;
		const isDevEnv = config.ENV === 'development';

		if (isDevOnly && !isDevEnv) return false;

		return allowedKeys.includes(route.key);
	});
};
